class VideoBanner extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.iframes = this.querySelectorAll('iframe');
    this.playButton = this.querySelector('.video-banner__play-button');
    this.section = this.querySelector('.video-banner-section');
    this.isAutoplay = this.dataset.autoplay === 'true';

    this.initThumbnailPreview();

    if (this.playButton) {
      this.playButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.togglePlay();
      });
    }

    if (this.section) {
      this.section.addEventListener('click', (e) => {
        if (e.target.closest('a, .video-banner__bottom-buttons, .video-banner__play-button')) return;
        this.togglePlay();
      });
    }

    if (this.isAutoplay && this.videos.length > 0) {
      // Autoplay is handled by HTML attributes, but we ensure state is synced
      this.section.classList.add('is-playing');
    }
  }

  initThumbnailPreview() {
    if (this.isAutoplay) return;

    this.videos.forEach(video => {
      const seekAttr = video.getAttribute('data-seek-thumbnail');
      const seekTime = seekAttr ? parseFloat(seekAttr) : 0;
      if (seekTime <= 0) return;

      const setPreviewFrame = () => {
        if (!video.dataset.hasPlayed && video.currentTime === 0) {
          try {
            const target = (video.duration && video.duration > 0 && video.duration < seekTime)
              ? (video.duration / 2)
              : seekTime;
            video.currentTime = target;
          } catch(err) {}
        }
      };

      if (video.readyState >= 1) {
        setPreviewFrame();
      } else {
        video.addEventListener('loadedmetadata', setPreviewFrame, { once: true });
        video.addEventListener('loadeddata', setPreviewFrame, { once: true });
      }
    });
  }

  togglePlay() {
    const isPlaying = this.section.classList.contains('is-playing');

    if (this.videos.length > 0) {
      if (!isPlaying) {
        this.videos.forEach(video => {
          const parentMedia = video.closest('.video-banner__media');
          if (parentMedia && window.getComputedStyle(parentMedia).display === 'none') {
            return;
          }

          const seekAttr = video.getAttribute('data-seek-thumbnail');
          const seekTime = seekAttr ? parseFloat(seekAttr) : 0;
          if (seekTime > 0 && !video.dataset.hasPlayed) {
            try {
              video.currentTime = 0;
            } catch(err) {}
            video.dataset.hasPlayed = 'true';
          }
          video.play().catch(() => {});
        });
        this.section.classList.add('is-playing');
      } else {
        this.videos.forEach(video => {
          try {
            video.pause();
          } catch(err) {}
        });
        this.section.classList.remove('is-playing');
      }
    } else if (this.iframes.length > 0) {
      // Basic toggle for iframe if possible, usually requires specific API (like YouTube/Vimeo)
      // Since it's a simple toggle, we just swap class for visual state if they click
      this.section.classList.toggle('is-playing');
    }
  }
}

customElements.define('video-banner', VideoBanner);
